import React from 'react'

import styled from '../../constants/theme'
import FormElement from '../../../src/components/forms/FormElement'
import {
  CommonFormElementProps,
  ElementType,
  Field,
} from '../../../src/components/forms/FormElementParts'

interface Props {
  commonProps: CommonFormElementProps
  field: Field
}

export default ({ commonProps, field }: Props) => {
  const { onChange } = commonProps
  const { label, name, options } = field
  const [checkedValues, setCheckedValues] = React.useState<string[]>([])
  const handleChange = React.useCallback(
    obj => {
      const value = Object.keys(obj)[0]
      const isNone = !!field.falsyValues?.includes(value)
      const checked = obj[value] === 'true'
      let newValues: string[]
      if (checked) {
        if (isNone) {
          newValues = [value]
        } else {
          newValues = [
            ...checkedValues.filter(val => !field.falsyValues?.includes(val)),
            value,
          ]
        }
      } else {
        newValues = checkedValues.filter(val => val !== value)
      }
      setCheckedValues(newValues)
      if (name) {
        onChange?.({ [name]: newValues })
      }
    },
    [checkedValues, field, name, onChange],
  )
  return (
    <Wrapper className="MultiselectQuestion">
      <GroupLabel
        id={`${name}Label`}
        dangerouslySetInnerHTML={{
          __html: label || '',
        }}
      />
      <Options aria-labelledby={`${name}Label`}>
        {options?.map((option, index) => (
          <FormElement
            key={`${name}_option_${option.value}_${index}`}
            label={option.label}
            name={`${option.value}`}
            onChange={handleChange}
            value={`${checkedValues.includes(`${option.value}`)}`}
            type={ElementType.CHECKBOX}
          />
        ))}
      </Options>
    </Wrapper>
  )
}

const Wrapper = styled.div({ marginTop: 20 })

const GroupLabel = styled.div(
  {
    fontWeight: 'bold',
    marginBottom: 20,
  },
  ({ theme }) => ({
    color: theme.text,
    fontFamily: theme.fontFamily,
  }),
)

const Options = styled.div({ marginLeft: 8 })
